import { EmptyState } from './EmptyState';
import { TFunction } from 'i18next';
import { Card } from './Card';
import { MapPinIcon } from '@heroicons/react/24/solid';

type SubAccountsEmptyStateProps = {
    t: TFunction;
};
export const SubAccountsEmptyState = ({ t }: SubAccountsEmptyStateProps) => {
    return (
        <Card
            title="SIMs Statistics"
            icon={<MapPinIcon className="w-6 h-6 text-primary opacity-45" />}
            content={
                <EmptyState
                    title={t(
                        'pages.dashboard.widgets.EmptyState.subAccounts.title'
                    )}
                    description={t(
                        'pages.dashboard.widgets.EmptyState.subAccounts.description'
                    )}
                />
            }
        />
    );
};
